"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformCurrencyISOToCurrency = transformCurrencyISOToCurrency;
const legacy_enums_1 = require("@daytrip/legacy-enums");
function transformCurrencyISOToCurrency(currencyISO) {
    switch (currencyISO.toUpperCase()) {
        case "EUR":
            return legacy_enums_1.Currency.Euro;
        case "USD":
            return legacy_enums_1.Currency.Dollar;
        case "CAD":
            return legacy_enums_1.Currency.CanadianDollar;
        case "AUD":
            return legacy_enums_1.Currency.AustralianDollar;
        case "GBP":
            return legacy_enums_1.Currency.BritishPound;
        case "NZD":
            return legacy_enums_1.Currency.NewZealandDollar;
        case "CZK":
            return legacy_enums_1.Currency.CzechKoruna;
        case "MXN":
            return legacy_enums_1.Currency.MexicanPeso;
        default:
            return legacy_enums_1.Currency.Euro;
    }
}
//# sourceMappingURL=transformCurrencyISOToCurrency.js.map